import PropTypes from "prop-types"

import Button from "components/ui/button"
import { jewlr_t } from "helpers/application"
import scrollToElement from "helpers/scroll-to-element"
import { cn } from "styles/utils"

const WarrantyButtons = ({ setShowExtend }) => {
  return (
    <div
      className={cn(
        "large:gap-40 desktop:mb-60 widescreen:max-w-1400 mx-auto mb-32 grid grid-cols-1 justify-center gap-20",
        sl.config.enable_extend_warranty
          ? "desktop:grid-cols-3"
          : "desktop:grid-cols-2 desktop:max-w-980"
      )}
    >
      <Button
        onClick={() => scrollToElement("#warranty-details")}
        variant="primary"
      >
        <p className="body font-semibold uppercase">
          {jewlr_t("terms.Jewelry")} One-Year Warranty
        </p>
      </Button>

      <Button
        onClick={() => scrollToElement("#luxury-bridal-collection")}
        variant="primary"
      >
        <p className="body font-semibold uppercase">
          Luxury Bridal LifeTime Warranty
        </p>
      </Button>

      {sl.config.enable_extend_warranty && (
        <Button
          onClick={() => {
            setShowExtend(true)
            scrollToElement("#jewlr-extend-warranty")
          }}
          variant="primary"
        >
          <p className="body font-semibold uppercase">
            Jewlr + Extend Warranty
          </p>
        </Button>
      )}
    </div>
  )
}

WarrantyButtons.propTypes = {
  setShowExtend: PropTypes.func,
}

export default WarrantyButtons
